__turbopack_context__.v({
  "container": "footer-cta-module-scss-module__klu1aa__container",
  "downloadApp": "footer-cta-module-scss-module__klu1aa__downloadApp",
  "headingContainer": "footer-cta-module-scss-module__klu1aa__headingContainer",
});
